import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AdaSectionDivider = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path
      d="M6.909 5h17.091c0.552 0 1 0.448 1 1v4.682c0 0.552-0.448 1-1 1h-17.091c-0.552 0-1-0.448-1-1v-4.682c0-0.552 0.448-1 1-1zM6.909 19.318h17.091c0.552 0 1 0.448 1 1v4.682c0 0.552-0.448 1-1 1h-17.091c-0.552 0-1-0.448-1-1v-4.682c0-0.552 0.448-1 1-1zM4.955 14.545h21c0.527 0 0.955 0.427 0.955 0.955s-0.427 0.955-0.955 0.955h-21c-0.527 0-0.955-0.427-0.955-0.955s0.427-0.955 0.955-0.955z"
    />
  </SvgIcon>
);

export default AdaSectionDivider;
